import React, { useState } from 'react'
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import {
  Card,
  Form,
  Button
} from "tabler-react";
import { optinUpload } from '../../services/client';

 function UploadForm({ onSubmit }) {

  const [fileObj, setFileObj] = useState(null)

  const onChangeFile = (event) => {
    if (event.target.files && event.target.files.length && event.target.files[0]) {
      setFileObj(event.target.files[0])
    }
    else {
      setFileObj(null)
    }
  }


  const handleSubmit = async (e) => {
    try {
      e.preventDefault()
      if (!fileObj) {
        toast.error("Please select a file")
        return;
      }

      let formdata = new FormData()
      formdata.append('opt_in', fileObj)
      const res = await optinUpload(formdata)
      console.log("res", res)
      toast.success("Success")
      if(onSubmit)
        onSubmit()


    } catch (error) {
      console.error(error)
      toast.error("Something went wrong")
    }
  }

  const downloadSampleCSV = () => {
    // Create sample CSV data
    const sampleData = [
      ['mobile number'],
      ['917845XXXXXX'],
    ];

    const csvContent = sampleData.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'sample-upload-template.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    toast.success("Sample CSV downloaded")

  };

  return (
    <Card>
      <Card.Header>
        <Card.Title>Upload Opt In</Card.Title>
      </Card.Header>
      <Card.Body>

        <div onClick={downloadSampleCSV} style={{color: "#007bff", cursor: "pointer", textDecoration: "underline"}}>Download Sample</div>
        <form id="csvForm" onSubmit={handleSubmit}>
          <Form.FieldSet className="col-lg-12">
            <Form.Group label="" className="upload-cont" >
              <div className="row card-header">
                <div className="col-sm-12">
                  <span className="form-label"> Csv Opt in Upload:</span>
                  <div className="file">
                    <span className="file-custom">
                      <input
                        id="csv"
                        name="example-text-input"
                        type="file"
                        onChange={(e) => onChangeFile(e)} />
                    </span>
                  </div>
                </div>
              </div>
            </Form.Group>
            <Button color="primary btn-block " className=" btn-block aligncentre" type="submit">Submit</Button>
          </Form.FieldSet>
        </form>
      </Card.Body>
      <ToastContainer autoClose={5000} position={'bottom-right'} />
    </Card>
  )
}
export default withRouter(UploadForm);